import client from '../utils/client'
import { gql } from '@apollo/client'

import { MutationHandlerResult } from '../utils/errors'

const SET_ONBOARDING_STEP = gql`
	mutation SetOnboardingStep($restaurantId: ID!, $step: String!, $done: Boolean!) {
		setOnboardingStep(restaurantId: $restaurantId, step: $step, done: $done) {
			success
		}
	}
`

const setOnboardingStep = async ({
	restaurantId,
	step,
	done,
}: {
	restaurantId: string
	step: string
	done: boolean
}): Promise<MutationHandlerResult> => {
	try {
		const { errors } = await client.mutate({
			mutation: SET_ONBOARDING_STEP,
			variables: { restaurantId, step, done },
			refetchQueries: ['CurrentUser'],
		})

		if (errors) {
			return { success: false, errors }
		}

		return { success: true, errors: null }
	} catch (e: unknown) {
		if (e && typeof e === 'object' && 'networkError' in e)
			return { success: false, errors: 'NETWORK_ERROR' }
		throw e
	}
}

export default setOnboardingStep
